import React from 'react';
import PropTypes from 'prop-types';

import RightPane from './RightPane';
import BottomPane from './BottomPane';
import SettingsForm from './SettingsForm';

import withToolsetPlaceholder from 'components/ToolsetPlaceholder';

const LinearModelComponent = props =>
  <div className="page-main__indent">
    <div className="flex">
      <div className="settings-width mb-15 mr-15">
        <SettingsForm />
      </div>

      {props.showRightAndBottomPanes &&
        <div className="graph-width mb-15">
          <RightPane />
        </div>
      }
    </div>

    {props.showRightAndBottomPanes &&
      <BottomPane />
    }
  </div>;

LinearModelComponent.propTypes = {
  showRightAndBottomPanes: PropTypes.bool.isRequired
};

export default withToolsetPlaceholder(
  LinearModelComponent
);
